const doc = [({"da":({"js":({"agenda_item_elements":({"edit":({"document":({"choose_document_file":"Vælg dokument"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;